/**
 * @author John Lukose <john.lukose@quikr.com>
 *
 * Utility functions for filter
 */
import FetchHelper from '../FetchHelper';
import UrlBuilder from '../Search/UrlBuilder';
import { getParamFromUrl } from '../index';
import { firePageLoadGa } from '../GaHelper';
import { BIG_BROTHER_EVENTS } from '../BigBrotherAnalytics/constants';
import BigBrotherAnalytics from '../BigBrotherAnalytics';
import root from 'window-or-global';


let urlBuilder = new UrlBuilder();
let fetchHelper = new FetchHelper();

/**
 * @function Set the default filter values from the url
 */
export function setFiltersFromUrl(defaultFilters, currentUrl='', snbUrlWithParam = '') {

	let urlparams = root.location && urlBuilder.parseSnbUrl(root.location.pathname);

	// the logic below assumes all the parameter recevied are in there correct format
	// and its in lower
	if (!urlparams && currentUrl) {
		urlparams = urlBuilder.parseSnbUrl(currentUrl);
	}

	Object.keys(defaultFilters.filters).forEach((key) => {
		if (urlparams && urlparams[key]) {
			switch (key) {
				case 'role': {
					defaultFilters.filters[key].selected = urlparams.role;
					defaultFilters.filters[key].subrole.selected = urlparams.subrole ? urlparams.subrole : [] ; break;
				}
				case 'city': {
					let city = urlparams.city.length > 0 ? urlparams.city[0] : '';
					defaultFilters.filters[key].selected = [];

					if ('all-candidate-profiles' !== city)
						defaultFilters.filters[key].selected = [city];

					break;
				}
				case 'locality': defaultFilters.filters[key].selected = urlparams.locality; break;
				case 'salary': {
					let salary = urlparams.salary.length > 0 ? urlparams.salary[0] : '';
					defaultFilters.filters[key].selected = [];
					salary = salary.replace('salary-', '');
					salary = salary.replace('rs', '');

					if (salary)
						defaultFilters.filters[key].selected[0] = parseInt(salary);

					break;
				}
				case 'type': defaultFilters.filters[key].selected = urlparams.type; break;
				case 'company': defaultFilters.filters[key].selected = urlparams.company; break;
				case 'keyword': defaultFilters.filters[key].selected = urlparams.keyword; break;
				case 'sort': defaultFilters.filters[key].selected = urlparams.sort; break;
				default: break;
			}
		}
	});

	defaultFilters.selectedFilters = {};
	//  console.log(' default url param received from url', defaultFilters.filters);
	Object.keys(defaultFilters.filters).forEach((key) => {
		if (defaultFilters.filters[key].selected) {
			if (key === 'keyword' && defaultFilters.filters[key].selected && defaultFilters.filters[key].selected.length > 0 ){
				defaultFilters.isSearch = true;
			}

			defaultFilters.selectedFilters[key] =  defaultFilters.filters[key].selected;

			if (('undefined' !==  typeof defaultFilters.filters.role.subrole.selected)  && (defaultFilters.filters.role.subrole.selected.length > 0)){
				for (let i = 0; i < defaultFilters.filters.role.subrole.selected.length; i++) {
					defaultFilters.selectedFilters.role.subrole =  defaultFilters.filters.role.subrole.selected;
					defaultFilters.selectedFilters.subrole =  defaultFilters.filters.role.subrole.selected;
				}
			}
		}
	});

	defaultFilters.selectedFilters['isMyNorthEastCityFilter']  = false; //default
	defaultFilters.selectedFilters['northEastFilter'] = getNorthEastFilter(snbUrlWithParam);
	
    return defaultFilters;
}

function getNorthEastFilter(url) {

  let urlparams = (root.location && root.location.href) ? root.location.href : "" ;
  if (!urlparams && url) {
		urlparams = url;
  }
 
  let query = urlparams ? urlparams.split("?")[1] : "";
  const filter = query
      ? (/^[?#]/.test(query) ? query.slice(1) : query)
          .split("&")
          .reduce((params, param) => {
            let [key, value] = param.split("=");
            params[key] = value
              ? decodeURIComponent(value.replace(/\+/g, " "))
              : "";
              return params;
            }, {})
        : {};

   return filter; 
};

export function handleAMPActions(defaultFilters) {
    let action = getParamFromUrl("ac");

    if ('filter' === action) {
        defaultFilters.popupOpened = 1;
    } else if ('sort' === action) {
      defaultFilters.filters['sort'].sortPopupOpened = 1;
    }

    return defaultFilters;
}

/**
 * @function Get the filter values from server data
 */
export function getFilterData(city) {
	let params = {
		url: root.location.protocol + '//www.quikr.com/jobs/jobsAjax/filterData?getrole=1&getlocation=1&city=' + city
	};
	return fetchHelper.request('GET', params);
}

export function getRoleFromUrlValue(state, urlRole) {
	let roleOptions = state.filters.role.options;

	for (let i=0; i<roleOptions.length; i++) {
		let role = roleOptions[i];

		if (role.value === urlRole)
			return role;
	}
}


/**
 * @function Set the filter values from server data
 */
export function setFilterData(state, response) {
	state.loaded = 1;

	// setting localities
	if (typeof response.data.json.location !== 'undefined' && response.data.json.location) {
		let locations = Object.keys(response.data.json.location).map(key => response.data.json.location[key]);
		let filterLocations = [];

		for (let i = 0; i < locations.length; i++) {
			let location = locations[i];
			filterLocations.push({
				id: location.id,
				value: location.value,
				displayValue: location.name
			});
		}
		state.filters.locality.options = filterLocations;
		state.filters.locality.displayInFilter = 1;
	}

	// setting roles
	if (typeof response.data.json.roles !== 'undefined' && response.data.json.roles) {
		let roles = Object.keys(response.data.json.roles).map(key => response.data.json.roles[key]);
		let filterRoles = [];

		for (let i = 0; i < roles.length; i++) {
			let role = roles[i];
			filterRoles.push({
				id: role.id,
				value: role.value,
				displayValue: role.name,
				subOptions: role.subRoles
			});
		}
		state.filters.role.options = filterRoles;
		state.filters.role.displayInFilter = 1;
	}

	//Setting Company
	if (typeof response.data.json.companies !== 'undefined' && response.data.json.companies) {
		let companies = Object.keys(response.data.json.companies).map(key => key);

		let filterCompanies = [];


		for (let i = 0; i < companies.length; i++) {
			let company = companies[i];
			if (company === 'Individual'){
				continue;
			}
			filterCompanies.push({
				id: company,
				value: company,
				displayValue: company
			});
		}
		if (filterCompanies.length > 0 &&  !(state.filters.company && state.filters.company.selected.length>0)) {
			state.filters.company.options = filterCompanies;
			state.filters.company.displayInFilter = 1;
		}
		state.loaded = 0;
	}

	return state;
}

/**
 * @function Get url from current filter state
 */
export function getUrlFromFilters(state) {
	let filters = {};

	// preparing input object for urlbuilder function
	if (state.filters.role.selected.length > 0)
		filters.role     = state.filters.role.selected;

	if (state.filters.role.subrole.selected.length > 0){
		filters.subrole = [];
		for (let i = 0; i < state.filters.role.subrole.selected.length; i++) {
			filters.subrole.push(state.filters.role.subrole.selected[i]);
		}
	}

	if (state.filters.city.selected.length > 0)
		filters.city  = state.filters.city.selected;

	if (state.filters.locality.selected.length > 0 && 1 == state.filters.locality.displayInFilter) {
		filters.locality = [];
		for (let i = 0; i < state.filters.locality.selected.length; i++) {
			filters.locality.push(state.filters.locality.selected[i].replace(/\s+/g, '-').toLowerCase());
		}
	}

	if (state.filters.salary.selected.length > 0 && 1 == state.filters.salary.displayInFilter) {
		let salary = state.filters.salary.selected[0];
		filters.salary = [];
		filters.salary[0] = 'salary-' + salary + 'rs';
	}

	if (state.filters.type.selected.length > 0 && 1 == state.filters.type.displayInFilter)
		filters.type   = state.filters.type.selected;

	if (state.filters.company.selected.length > 0 && 1 == state.filters.company.displayInFilter)
		filters.company   = state.filters.company.selected;

	if (state.filters.sort.selected.length > 0)
		filters.sort   = state.filters.sort.selected;

	if (state.filters.keyword.selected.length > 0)
		 filters.keyword   = state.filters.keyword.selected;

	//Added For SEO.TODO: NORMALIZE TABLE
	Object.keys(state.filters).forEach((key) => {
		if (state.filters[key].selected) {
			state.selectedFilters[key] =  state.filters[key].selected;
			if (state.filters[key].subOptionsKey) {
				let subKey = state.filters[key].subOptionsKey;
				state.selectedFilters[subKey] = state.filters[key][subKey].selected;
			}
		}
	});
	let url = urlBuilder.getJobsSnbUrl(filters);
	return url;
}

/**
 * @function Fire GA events for candidate filters
 */
export function fireEventForFilter(state) {
	let filters = state.filters;

	if(filters.role.selected.length > 0){
		fireGAEvent('role');
		let data = {
			role : filters.role.selected
		}
		fireBigBrotherEvent(data);
	}
	if(filters.role.subrole.selected.length > 0){
		fireGAEvent('subRole');
		let data = {
			subRole : filters.role.subrole.selected
		}
		fireBigBrotherEvent(data);
	}
	if(filters.salary.selected.length > 0){
		fireGAEvent('salary');
		let data = {
			salary : filters.salary.selected
		}
		fireBigBrotherEvent(data);
	}
	if(filters.company.selected.length > 0){
		fireGAEvent('company');
		let data = {
			company : filters.company.selected
		}
		fireBigBrotherEvent(data);
	}
	if(filters.locality.selected.length > 0){
		fireGAEvent('locality');
		let data = {
			locality : filters.locality.selected
		}
		fireBigBrotherEvent(data);
	}
	if(filters.type.selected.length > 0){
		fireGAEvent('jobType');
		let data = {
			jobType : filters.type.selected
		}
		fireBigBrotherEvent(data);
	}
}

function fireGAEvent(filter) {
	firePageLoadGa('applyFilter',{pwa_candidate: filter});
}

function fireBigBrotherEvent(filter){
	let data = {
		"filterSelect" : filter
	};
	BigBrotherAnalytics.mapObjectDataToJSONData( data ,BIG_BROTHER_EVENTS.jobsSnBFilterSelect);
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Filter/index.js